import React, { useRef, useState } from 'react';

const MAXIMO_LADO = 1600;

const lerArquivo = arquivo => new Promise((resolve, reject) => {
    const leitor = new FileReader();
    leitor.onerror = () => reject(new Error('Não foi possível ler o arquivo.'));
    leitor.onload = evento => resolve(evento.target.result);
    leitor.readAsDataURL(arquivo);
});

const reduzirImagem = async arquivo => {
    const origem = await lerArquivo(arquivo);
    return new Promise((resolve, reject) => {
        const imagem = new Image();
        imagem.onerror = () => reject(new Error('Imagem inválida.'));
        imagem.onload = () => {
            const proporcao = Math.min(
                1,
                MAXIMO_LADO / Math.max(imagem.width, imagem.height)
            );
            const canvas = document.createElement('canvas');
            canvas.width = Math.round(imagem.width * proporcao);
            canvas.height = Math.round(imagem.height * proporcao);
            canvas.getContext('2d').drawImage(
                imagem, 0, 0, canvas.width, canvas.height
            );
            resolve(canvas.toDataURL('image/jpeg', .82));
        };
        imagem.src = origem;
    });
};

export default props => {
    const arquivoRef = useRef(null);
    const cameraRef = useRef(null);
    const [erro, setErro] = useState('');
    const valor = props.value;

    const selecionar = async evento => {
        const arquivo = evento.target.files[0];
        evento.target.value = '';
        if (!arquivo) return;
        if (!arquivo.type.startsWith('image/') &&
            arquivo.type !== 'application/pdf') {
            setErro('Selecione uma imagem ou PDF.');
            return;
        }
        if (arquivo.size > 5 * 1024 * 1024) {
            setErro('O arquivo não pode ultrapassar 5 MB.');
            return;
        }
        try {
            setErro('');
            const conteudo = arquivo.type.startsWith('image/')
                ? await reduzirImagem(arquivo)
                : await lerArquivo(arquivo);
            props.onChange({
                comprovante: conteudo,
                comprovante_nome: arquivo.name,
                comprovante_tipo: arquivo.type
            });
        } catch (ex) {
            setErro(ex.message);
        }
    };

    return (
        <div className='form-group'>
            <label>Comprovante</label>
            {valor &&
                <div style={{ marginBottom: 8 }}>
                    {props.tipo === 'application/pdf'
                        ? <a href={valor} target='_blank' rel='noopener noreferrer'>
                            Abrir {props.nome || 'PDF'}
                        </a>
                        : <a href={valor} target='_blank' rel='noopener noreferrer'>
                            <img
                                src={valor}
                                alt='Comprovante'
                                style={{
                                    maxWidth: 280,
                                    maxHeight: 200,
                                    objectFit: 'contain',
                                    border: '1px solid #d7dce1',
                                    borderRadius: 6
                                }}
                            />
                        </a>}
                </div>}
            {!props.readOnly && <div>
                <button
                    type='button'
                    className='btn btn-primary btn-sm'
                    onClick={() => arquivoRef.current.click()}
                >
                    <i className='fas fa-paperclip' /> Anexar
                </button>{' '}
                <button
                    type='button'
                    className='btn btn-info btn-sm'
                    onClick={() => cameraRef.current.click()}
                >
                    <i className='fas fa-camera' /> Fotografar
                </button>{' '}
                {valor && <button
                    type='button'
                    className='btn btn-danger btn-sm'
                    onClick={() => props.onChange({
                        comprovante: null,
                        comprovante_nome: null,
                        comprovante_tipo: null
                    })}
                >Remover</button>}
                <input
                    ref={arquivoRef}
                    type='file'
                    accept='image/*,application/pdf'
                    style={{ display: 'none' }}
                    onChange={selecionar}
                />
                <input
                    ref={cameraRef}
                    type='file'
                    accept='image/*'
                    capture='environment'
                    style={{ display: 'none' }}
                    onChange={selecionar}
                />
            </div>}
            {erro && <div className='text-danger'>{erro}</div>}
        </div>
    );
};
